import { Box, Container, Grid, makeStyles, Paper, Tab, Theme } from '@material-ui/core';
import { TabContext, TabPanel } from '@mui/lab';
import TabList from '@mui/lab/TabList';
import React from 'react';
import Automations from './automations';
import AutomationAnalytics from './automation-analytics';
import AutomationQueue from './automation-qeue';

const useStyles = makeStyles((theme: Theme): any => ({
  container: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
}));

function AutomationPage(): React.ReactElement {
  const classes: any = useStyles();

  const [value, setValue] = React.useState('1');

  const handleChange = (event: React.SyntheticEvent, tabValue: string) => {
    setValue(tabValue);
  };

  return (
    <Container className={classes.container} maxWidth="lg" >

      <TabContext value={value}>
        <Grid container justifyContent="center">
          <Grid item xs={11}>
            <Paper square style={{ marginBottom: 10 }}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList onChange={handleChange} aria-label="automation tabs" style={{ fontSize: 'small' }}>
                  <Tab label="Automations" value="1" />
                  <Tab label="Analytics" value="2" />
                  <Tab label="Queue" value="3" />
                </TabList>
              </Box>
            </Paper>
          </Grid>

          <Grid item xs={1}>
          </Grid>

        </Grid>


        <TabPanel value="1" style={{ padding: 0 }}>
          <Automations />
        </TabPanel>

        <TabPanel value="2" style={{ padding: 0 }}>
          <Grid container justifyContent="center">
            <Grid item xs={11}>

              <AutomationAnalytics />
            </Grid>

            <Grid item xs={1}>
            </Grid>

          </Grid>
        </TabPanel>
        <TabPanel value="3" style={{ padding: 0 }}>
          <Grid container justifyContent="center">
            <Grid item xs={11}>
              <AutomationQueue />
            </Grid>

            <Grid item xs={1}>
            </Grid>

          </Grid>
        </TabPanel>
      </TabContext>
    </Container>
  );
}

export default AutomationPage;
